import * as type from "./action-type";
import icon01 from '../../assets/images/home/wordicon01.png'
import icon02 from '../../assets/images/home/wordicon02.png'
import icon03 from '../../assets/images/home/wordicon03.png'
import icon04 from '../../assets/images/home/wordicon04.png'
import icon05 from '../../assets/images/home/wordicon05.png'
import icon06 from '../../assets/images/home/wordicon06.png'
import icon07 from '../../assets/images/home/wordicon07.png'
import icon08 from '../../assets/images/home/wordicon08.png'

let _state = {
    dataCount: {},

    currHotTab: 0,
    // 热门数据Tab
    hotDataTabs: [
        '人口综合状况',
        '人口受教育情况',
        '人口老龄化'
    ],
    censusData: [ // 最新人口普查数据
        {
            icon: icon01,
            name: '人口',
            itemList: [
                {name: '户数、人口数和性别比', fileCode: 'N2022060068000005'},
                {name: '分性别的15岁及以上文盲人口', fileCode: 'N2022060068000029'},
                {name: '家庭户的住房间数和面积', fileCode: 'N2022060068000049'}
            ]
        },
        {
            icon: icon02,
            name: '民族',
            itemList: [
                {name: '各民族分年龄、性别的人口', fileCode: 'N2022060068000058'},
                {name: '各民族分性别、受教育程度的3岁及以上人口', fileCode: 'N2022060068000062'}
            ]
        },
        {
            icon: icon03,
            name: '年龄',
            itemList: [
                {name: '全国分年龄、性别的人口', fileCode: 'N2022060068000071'},
                {name: '人口年龄构成（一）', fileCode: 'N2022060068000075'},
                {name: '人口年龄构成（二）', fileCode: 'N2022060068000079'}
            ]
        },
        {
            icon: icon04,
            name: '受教育程度',
            itemList: [
                {name: '分年龄、性别、受教育程度的3岁及以上人口', fileCode: 'N2022060068000084'},
                {name: '分性别、受教育程度的25岁及以上人口', fileCode: 'N2022060068000096'},
                {name: '分年龄、性别的15岁及以上文盲人口', fileCode: 'N2022060068000100'}
            ]
        },
        {
            icon: icon05,
            name: '家庭',
            itemList: [
                {name: '全国不同规模的家庭户类别', fileCode: 'N2022060068000105'},
                {name: '各地区分年龄、性别的一人户', fileCode: 'N2022060068000109'},
                {name: '各地区有60岁及以上人口的家庭户户数', fileCode: 'N2022060068000117'}
            ]
        },
        {
            icon: icon06,
            name: '死亡',
            itemList: [
                {name: '各地区分年龄、性别的死亡人口', fileCode: 'N2022060068000130'},
                {name: '各地区分性别、婚姻状况的15岁及以上死亡人口', fileCode: 'N2022060068000138'},
                {name: '全国分年龄、性别的死亡人口状况', fileCode: 'N2022060068000142'},
            ]
        },
        {
            icon: icon07,
            name: '户口登记状况',
            itemList: [
                {name: '按现住地、户口登记地、性别分的户口登记地在外乡镇街道的人口', fileCode: 'N2022060068000147'},
                {name: '按现住地、受教育程度、性别分的户口登记地在外省的人口', fileCode: 'N2022060068000171'}
            ]
        },
        {
            icon: icon08,
            name: '住房',
            itemList: [
                {name: '按住房间数分的家庭户户数', fileCode: 'N2022060068000188'},
                {name: '按人均住房建筑面积分的家庭户户数', fileCode: 'N2022060068000192'},
                {name: '按户主的受教育程度分的家庭户住房状况', fileCode: 'N2022060068000200'},
            ]
        },
    ],

    // 最新人口普查公报数据
    statNews: [],

    //最新普查资料
    yearbookList: [],

    //热门数据
    charts: [null, null, null],
    echart0: {
        title: '历次人口普查全国人口及年均增长率',
        unitBar: '万人',
        unitLine: '%',
        valuesBar: [
            '58260',
            '69458',
            '100818',
            '113368',
            '126583',
            '133972',
            '141178'
        ],
        valuesLine: [
            '',
            '1.61',
            '2.09',
            '1.48',
            '1.07',
            '0.57',
            '0.53'
        ],
        years: [
            '1953年',
            '1964年',
            '1982年',
            '1990年',
            '2000年',
            '2010年',
            '2020年'
        ],
    },
    echart1: {
        title: '历次人口普查人口性别构成',
        unitBar: '万人',
        menValuesBar: [
            '30190',
            '35652',
            '51944',
            '58495',
            '65355',
            '68685',
            '72334'
        ],
        womenValuesBar: [
            '28070',
            '33806',
            '48874',
            '54873',
            '61228',
            '65287',
            '68844'
        ],
        valuesLine: [
            '107.56',
            '105.46',
            '106.3',
            '106.6',
            '106.74',
            '105.2',
            '105.07'
        ],
        years: [
            '1953年',
            '1964年',
            '1982年',
            '1990年',
            '2000年',
            '2010年',
            '2020年'
        ]
    },
    echart2: {
        title: '历次人口普查城镇化率（%）',
        unit: '%',
        values: [
            '13.26',
            '18.30',
            '20.91',
            '26.44',
            '36.22',
            '49.68',
            '63.89'
        ],
        years: [
            '1953年',
            '1964年',
            '1982年',
            '1990年',
            '2000年',
            '2010年',
            '2020年'
        ]
    },
    echart3: {
        title: '历次人口普查每十万人拥有的各种受教育程度人口',
        unit: '人',
        dataSource: [
            ['product', '1964年', '1982年', '1990年', '2000年', '2010年', '2020年'],
            ['小学', 28330, 35237, 37057, 35701, 26779, 24767],
            ['初中', 4680, 17892, 23344, 33961, 38788, 34507],
            ['高中(含中专)', 1319, 6779, 8039, 11146, 14032, 15088],
            ['大学(大专及以上)', 416, 615, 1422, 3611, 8930, 15467],
        ],
    },
    echart4: {
        title: '第七次人口普查按性别分3岁及以上人口受教育程度',
        unitBar: '人',
        xAxisData: ['未上过学', '学前教育', '小学', '初中', '高中', '大专及以上'],
        menValuesBar: [
            '14455827',
            '27868882',
            '164893183',
            '263448804',
            '116996970',
            '111859915',
        ],
        womenValuesBar: [
            '34140110',
            '25486963',
            '184765550',
            '223646206',
            '95212952',
            '105364736',
        ],
    },
    echart5: {
        title: '历次人口普查文盲人口及文盲率',
        unitBar: '万人',
        unitLine: '%',
        valuesBar: [
            '23327',
            '22996',
            '18003',
            '8507',
            '5466',
            '3775',
        ],
        valuesLine: [
            '33.58',
            '22.81',
            '15.88',
            '6.72',
            '4.08',
            '2.67',
        ],
        years: [
            '1964年',
            '1982年',
            '1990年',
            '2000年',
            '2010年',
            '2020年'
        ],
    },
    echart6: {
        title: '第七次全国人口普查人口年龄金字塔',
        unit: '%',
        menValues: [
            '-2.91',
            '-3.41',
            '-3.42',
            '-2.77',
            '-2.81',
            '-3.42',
            '-4.53',
            '-3.61',
            '-3.38',
            '-4.13',
            '-4.33',
            '-3.60',
            '-2.62',
            '-2.58',
            '-1.71',
            '-0.65',
            '-0.31',
            '-0.10',
            '-0.02',
        ],
        womenValues: [
            '2.62',
            '3.00',
            '2.81',
            '2.39',
            '2.50',
            '3.10',
            '4.28',
            '3.41',
            '3.21',
            '3.97',
            '4.26',
            '3.59',
            '2.59',
            '2.67',
            '1.80',
            '1.17',
            '0.80',
            '0.16',
            '0.04',
            '0.01',
        ],
        yAxisData: [
            '0-4',
            '5-9',
            '10-14',
            '15-19',
            '20-24',
            '25-29',
            '30-34',
            '35-39',
            '40-44',
            '45-49',
            '50-54',
            '55-59',
            '60-64',
            '65-69',
            '70-74',
            '75-79',
            '80-84',
            '85-89',
            '90-94',
            '95-99',
            '100岁及以上',
        ],
    },
    echart7: {
        title: '历次人口普查65岁及以上人口(万人)',
        unit: '万人',
        values: [
            '2569.266',
            '2472.7048',
            '4950.1638',
            '6314.5976',
            '8810.1768',
            '11883.3164',
            '19063.528'
        ],
        years: [
            '1953年',
            '1964年',
            '1982年',
            '1990年',
            '2000年',
            '2010年',
            '2020年'
        ],
    },
    echart8: {
        title: '历次人口普查65岁及以上人口占比（%）',
        unit: '%',
        values: [
            '4.41',
            '3.56',
            '4.91',
            '5.57',
            '6.96',
            '8.87',
            '13.5'
        ],
        years: [
            '1953年',
            '1964年',
            '1982年',
            '1990年',
            '2000年',
            '2010年',
            '2020年'
        ],
    },
}

export const home = (state = _state, action = {}) => {
    switch (action.type) {
        case (type.handleKeyValue):
            state[[action.key]] = action.value;
            return {...state};
        case type.Get_Count:
            state.dataCount = action.data;
            return {...state};
        case type.GET_YearbookList:
            state.yearbookList = action.data;
            return {...state};
        case type.GET_StatNews:
            state.statNews = action.data;
            return {...state};
        case type.DrawEChart0: {
            state.charts[0] = action.chart;
            return {...state}
        }
        case type.DrawEChart1: {
            state.charts[1] = action.chart;
            return {...state}
        }
        case type.DrawEChart2: {
            state.charts[2] = action.chart;
            return {...state}
        }
        case type.DrawEChart3: {
            state.charts[3] = action.chart;
            return {...state}
        }
        default:
            return state;
    }
}
